import { previewAppPath } from '../../../util/paths';

// APP paths
export const rootPath = `${previewAppPath}`;

export default rootPath;
